const config = {
  mirimus: {
    name: 'Mirimus',
    id: 'mirimus',
    contacts: {
      email: 'testingsupport@mirimus.com',
    },
    timezone: 'America/New_York',
  },
  aclv: {
    name: 'Accelevir',
    id: 'aclv',
    contacts: {
      email: 'mhays@accelevir.com',
    },
    timezone: 'America/New_York',
  },
  wynn: {
    name: 'Mirimus',
    id: 'wynn',
    contacts: {
      email: 'testingsupport@mirimus.com',
    },
    timezone: 'America/Los_Angeles',
  },
};

export default config;
